import { CascadiaStandardIcon, standardIcons } from "./icons";

export function isCascadiaStandardIcon(
  value: unknown
): value is CascadiaStandardIcon {
  const iconKeys = Object.keys(standardIcons);
  if (typeof value != "string") {
    return false;
  }
  return iconKeys.includes(value);
}

export function parseCascadiaStandardIcon(
  value: unknown,
  defaultValue?: CascadiaStandardIcon | undefined
) {
  if (!isCascadiaStandardIcon(value)) {
    return defaultValue || "info";
  }
  return value;
}
